var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h32a4 4 0 014 4v32a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#009CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.475 20.024l6.858-6.836v13.73l-6.858-6.894zM7.917 29.167l7.375-7.375 3.53 3.528c.65.652 1.705.652 2.357 0l3.528-3.528 7.377 7.375s-.41.833-2.065.833H10.074c-1.545 0-2.157-.833-2.157-.833zm-1.25-15.99l6.857 6.847-6.857 6.844v-13.69zm6.2-3.177h17.802c.953 0 1.461.834 1.461.834l-7.423 7.421-1.767 1.769-2.94 2.94-2.94-2.94-1.768-1.769-7.423-7.421S8.485 10 9.332 10h3.535z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconEnvelope);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/appIconEnvelope.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };